export const RegexConst = {
  LETTER_UNICODE_AND_WHITESPACES: /^[\p{L}\s]+$/u,
  PHONE_NUMBER: /^\d{10}$/,
  EMAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  AT_LEAST_A_LETTER_AND_A_NUMBER: /^(?=.*\d)(?=.*[a-zA-Z])(?=\S+$)/,
  TWO_WORDS_ONLY_LETTERS_UNICODE_REGEX: /^(\p{L}{2,}[\p{Zs}]{1}\p{L}{2,}$){1,}/u,
  ZIP_CODE: /^\d{4,}(?:-\d{4})?$/,
  IMAGE_FORMAT: /(\.png|\.jpg|\.svg)/
};
